import React, { useEffect, useState } from 'react';
import CarouselScreen from './CarouselScreen';
import YoutubeGridScreen from './YoutubeGridScreen';
import HeaderNavbarComponent from './HeaderNavbar';
import LearnService from '../../services/LearnService';

export default function LearnLandingScreen() {
  const [trendingSeries, setTrendingSeries] = useState([]);
  const [allSeries, setAllSeries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);
      try {
        const res = await LearnService.getServiceItemList();
        const data = res.data || [];
        setTrendingSeries(data.filter(item => item.isTrendingSeries));
        setAllSeries(data.filter(item => !item.isTrendingSeries));
      } catch (e) {
        setTrendingSeries([]);
        setAllSeries([]);
      }
      setLoading(false);
    }
    fetchData();
  }, []);

  if (loading) return <div style={{color: "#fff", textAlign: "center", marginTop: 40}}>Loading...</div>;

  return (
    <div>
      <HeaderNavbarComponent />
      <CarouselScreen cards={trendingSeries} />
      <YoutubeGridScreen cards={allSeries} />
    </div>
  );
}
